import { render, staticRenderFns } from "./ChooseShiftsSlotForm.vue?vue&type=template&id=049c50d8"
import script from "./ChooseShiftsSlotForm.vue?vue&type=script&lang=ts"
export * from "./ChooseShiftsSlotForm.vue?vue&type=script&lang=ts"
import style0 from "./ChooseShiftsSlotForm.vue?vue&type=style&index=0&id=049c50d8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports